// extracted by mini-css-extract-plugin
export default {"header":"App_header__QMQca","link":"App_link__NbOnp","button":"App_button__J64kJ","subLink":"App_subLink__QL2bI","dropdownFooter":"App_dropdownFooter__7NW6o"};